import emailjs from "@emailjs/browser";

const EMAIL_PROVIDER = import.meta.env.VITE_EMAIL_PROVIDER || "emailjs";

/**
 * Envía email vía EmailJS (client-side)
 */
async function sendWithEmailJS({ name, email, phone, projectType, message }) {
  return emailjs.send(
    import.meta.env.VITE_APP_EMAILJS_SERVICE_ID,
    import.meta.env.VITE_APP_EMAILJS_TEMPLATE_ID,
    {
      from_name: name,
      to_name: "Guido Cohen Semag",
      from_email: email,
      to_email: "guidocohens@gmail.com",
      phone: phone || "",
      project_type: projectType || "",
      message,
    },
    import.meta.env.VITE_APP_EMAILJS_PUBLIC_KEY
  );
}

/**
 * Envía email vía Resend (Firebase Cloud Function)
 */
async function sendWithResend({ name, email, phone, projectType, message }) {
  const res = await fetch(import.meta.env.VITE_RESEND_FUNCTION_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, email, phone, projectType, message }),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error.message || "Error al enviar email con Resend");
  }

  return res.json();
}

export async function sendEmail(formData) {
  if (EMAIL_PROVIDER === "resend") {
    return sendWithResend(formData);
  }
  return sendWithEmailJS(formData);
}
